export default __webpack_public_path__ + "static/media/close_red.8cee3508.svg";